import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/NewsAndInfo.css";

function NewsAndInfo() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllNews = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Fetch news from both sources using backend endpoints
        const [backendResponse, externalResponse] = await Promise.allSettled([
          axios.get("/api/news"),
          axios.get("/api/news/external")
        ]);

        let allNews = [];

        // // Add news from database
        // if (backendResponse.status === 'fulfilled' && backendResponse.value.data) {
        //   const dbNews = backendResponse.value.data.map(item => ({
        //     ...item,
        //     source: 'database'
        //   }));
        //   allNews = [...allNews, ...dbNews];
        //   console.log(`Loaded ${dbNews.length} legal articles from database`);
        // } else if (backendResponse.status === 'rejected') {
        //   console.error('Database fetch failed:', backendResponse.reason);
        // }

        // Add news from external API (via backend)
        if (externalResponse.status === 'fulfilled' && externalResponse.value.data) {
          const apiNews = externalResponse.value.data;
          allNews = [...allNews, ...apiNews];
          // console.log(`Loaded ${apiNews.length} legal articles from external API`);
        } else if (externalResponse.status === 'rejected') {
          // console.error('External API fetch failed:', externalResponse.reason);
          if (externalResponse.reason.response?.data?.error) {
            setError(externalResponse.reason.response.data.error);
          } else {
            setError("Failed to fetch legal news from external API. Please try again later.");
          }
        }

        // Remove duplicates based on title
        const uniqueNews = allNews.filter((item, index, self) => 
          index === self.findIndex(t => t.title === item.title)
        );

        // Sort by date (newest first)
        uniqueNews.sort((a, b) => new Date(b.date) - new Date(a.date));
        
        setNews(uniqueNews);
        
        // console.log(`Total unique legal articles: ${uniqueNews.length}`);
        
        // If no news at all, show a message
        if (uniqueNews.length === 0) {
          setError("No legal news articles found. Please check your API configuration or try again later.");
        }
        
      } catch (err) {
        // console.error("Error in fetchAllNews:", err);
        setError("Failed to fetch legal news. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchAllNews();
  }, []);

  if (loading) {
    return (
      <div className="news-container">
        <div className="loading">Loading latest legal news...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="news-container">
        <div className="error">{error}</div>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button 
            onClick={() => window.location.reload()} 
            style={{
              padding: '10px 20px',
              backgroundColor: '#3498db',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  const indianNewsCount = news.filter(item => item.category === "Indian Legal").length;
  const generalNewsCount = news.filter(item => item.category === "Legal").length;

  return (
    <div className="news-container">
      <h2 className="news-title">Legal News & Court Updates</h2>
      <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px' }}>
        Stay updated with latest legal developments, court cases, and legal reforms worldwide, including Indian Supreme Court verdicts and High Court judgments
      </p>
      <div className="news-stats">
        <span>Total: {news.length} legal articles</span>
        <span>Indian: {indianNewsCount} articles</span>
        <span>General: {generalNewsCount} articles</span>
        {/* <span>Database: {news.filter(n => n.source === 'database').length}</span> */}
        <span>API: {news.filter(n => n.source === 'api').length}</span>
      </div>
      <div className="news-grid">
        {news.map((item) => (
          <div key={item._id} className="news-card">
            {item.image && (
              <div className="news-image">
                <img src={item.image} alt={item.title} />
                <div className="news-source-badge">
                  {item.category === "Indian Legal" ? "IN" : "GL"}
                </div>
              </div>
            )}
            <div className="news-content">
              <h3 className="news-heading">{item.title}</h3>
              <p className="news-description">
                {item.content && item.content.length > 150 
                  ? `${item.content.substring(0, 150)}...` 
                  : item.content}
              </p>
              <div className="news-meta">
                <span className="news-date">
                  {new Date(item.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </span>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <span style={{ 
                    fontSize: '0.8rem', 
                    padding: '2px 8px', 
                    borderRadius: '10px',
                    backgroundColor: item.category === "Indian Legal" ? '#ff6b6b' : '#4ecdc4',
                    color: 'white',
                    fontWeight: '500'
                  }}>
                    {item.category === "Indian Legal" ? "Indian Legal" : "General Legal"}
                  </span>
                  {item.url && (
                    <a 
                      href={item.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="news-link"
                    >
                      Read More
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {news.length === 0 && (
        <div className="no-news">
          No legal news articles found. Please try again later.
        </div>
      )}
    </div>
  );
}

export default NewsAndInfo; 